import { Injectable } from '@angular/core';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Modèles
import { Deposit } from 'src/app/@shared/models/banking/cheques/deposit.model';
import { Observable } from 'rxjs';

const CLASS_NAME = 'Deposit';
const ENDPOINT = `/deposits/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'account-entries', path: 'account-entries/', childClass: 'AccountEntryLine' },
]
const ROUTES: RouteParam[] = [
    { key: 'deposit', path: '{id}/deposit/' },
    { key: 'massDelete', path: 'mass-delete/' },
    { key: 'undeposit', path: '{id}/undeposit/' },
]

@Injectable({
    providedIn: 'root'
})
export class DepositService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    public deposit$(deposit: Deposit): Observable<Deposit> {
        let url = this.routes.deposit.replace('{id}', deposit.id.toString());
        return this.update$(deposit, {
            url: url
        });
    }

    public deposit(deposit: Deposit): void {
        let url = this.routes.deposit.replace('{id}', deposit.id.toString());
        return this.update(deposit, {
            url: url
        });
    }

    public undeposit$(deposit: Deposit): Observable<Deposit> {
        let url = this.routes.undeposit.replace('{id}', deposit.id.toString());
        return this.update$(deposit, {
            url: url
        });
    }

    public undeposit(deposit: Deposit): void {
        let url = this.routes.undeposit.replace('{id}', deposit.id.toString());
        return this.update(deposit, {
            url: url
        });
    }

}
